'use client';

import LegalDocumentView from '@/app/components/legal/LegalDocumentView';
import { LEGAL_EMAIL } from '@/lib/legal/business';
import {
  TERMS_IMPORTANT_NOTICE,
  TERMS_INTRO,
  termsSections,
} from '@/lib/legal/terms-sections';

export default function TermsPage() {
  return (
    <LegalDocumentView
      title="Terms of Use"
      subtitle="Please read these terms carefully before using our services"
      intro={TERMS_INTRO}
      sections={termsSections}
      noticeTitle="Important Notice"
      noticeParagraphs={TERMS_IMPORTANT_NOTICE}
      ctaTitle="Questions About Our Terms?"
      ctaSubtitle="Contact us if you have any questions about these Terms of Use."
      contactEmail={LEGAL_EMAIL}
      crossLink={{ href: '/privacy', label: 'View Privacy Policy' }}
    />
  );
}
